import React from "react";

export const TvTickerBar = ({ children }) => (
  <div className="relative min-h-0 overflow-hidden" data-testid="tv-ticker-zone">
    {children}
    <span className="absolute right-0 top-0 bottom-0 z-40 flex items-center px-5 bg-[#030712] border-l border-cyan-300/15 nx-orbitron text-[11px] tracking-[0.28em] text-cyan-100/50" data-testid="tv-powered-by">
      POWERED BY&nbsp;<b className="text-[#22d3ee]">A V TECH</b>
    </span>
  </div>
);
